module.exports = __webpack_public_path__ + "7bfc0e6886ec77eb36ca1df53fc5768f.svg";